import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://api.buildbright.app";

const SERVICES = ["roofing", "solar", "landscaping", "hvac", "plumbing", "electrical", "other"];
const SOURCES = ["yelp", "referral", "google", "facebook", "instagram", "cold-call", "walk-in", "other"];

export default function AdminAddLead() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState({
    name: "", phone: "", email: "",
    service: "roofing", zip: "",
    source: "yelp", notes: ""
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.zip) {
      setMsg("Name, phone and ZIP are required.");
      return;
    }
    setLoading(true);
    setMsg("");
    try {
      const res = await fetch(`${API}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: form.email,
          serviceType: form.service,
          service: form.service,
          zip: form.zip,
          utm_source: form.source,
          notes: form.notes,
          contact: {
            name: form.name,
            phone: form.phone,
            email: form.email,
          }
        })
      });
      const data = await res.json();
      if (data.ok) {
        setMsg("✅ Lead added successfully!");
        setForm({ name: "", phone: "", email: "", service: "roofing", zip: "", source: "yelp", notes: "" });
      } else {
        setMsg("❌ Failed: " + (data.detail || JSON.stringify(data)));
      }
    } catch (err) {
      setMsg("❌ Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white px-4 py-10">
      <div className="max-w-xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-zinc-400 text-sm mb-6 hover:text-white">
          ← Back
        </button>
        <h1 className="text-2xl font-bold mb-2">Add Lead Manually</h1>
        <p className="text-zinc-400 text-sm mb-8">Enter homeowner info from Yelp, referrals, or any source.</p>

        {msg && (
          <div className={`mb-6 p-3 rounded-lg text-sm ${msg.startsWith("✅") ? "bg-green-900 text-green-300" : "bg-red-900 text-red-300"}`}>
            {msg}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Homeowner Name *</label>
            <input className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
              value={form.name} onChange={e => set("name", e.target.value)} placeholder="John Smith" required />
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Phone *</label>
            <input className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
              value={form.phone} onChange={e => set("phone", e.target.value)} placeholder="(310) 555-1234" required />
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Email</label>
            <input className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
              value={form.email} onChange={e => set("email", e.target.value)} placeholder="john@email.com" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-zinc-400 mb-1">Service *</label>
              <select className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
                value={form.service} onChange={e => set("service", e.target.value)}>
                {SERVICES.map(s => <option key={s} value={s} className="capitalize">{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm text-zinc-400 mb-1">ZIP Code *</label>
              <input className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
                value={form.zip} onChange={e => set("zip", e.target.value)} placeholder="90210" required maxLength={5} />
            </div>
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Lead Source</label>
            <select className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2"
              value={form.source} onChange={e => set("source", e.target.value)}>
              {SOURCES.map(s => <option key={s} value={s} className="capitalize">{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Notes</label>
            <textarea className="w-full bg-zinc-900 border border-zinc-700 text-white rounded-lg px-3 py-2 h-20"
              value={form.notes} onChange={e => set("notes", e.target.value)} placeholder="Any details about the job..." />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white font-semibold py-3 rounded-lg">
            {loading ? "Adding..." : "Add Lead"}
          </button>
        </form>
      </div>
    </div>
  );
}
